import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import { getCompany } from "api/AccountsApi";
import { limitAudienceData, getOverAllCount, putSaveAudienceData } from "api/AudienceApi";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import { setAudienceLoading } from "ReduxStore/Slices/audienceSlice";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Table";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { toast } from "react-toastify";

const AudienceDetails = (props) => {

  const [dataApi, setDataApi] = useState([]);
  const [contact, setContact] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const dispatch = useDispatch();
  const { audienceLoading } = useSelector((state) => state.audienceSetter);
  const searchText = useRef("");
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        // width: 300,
        Header: "",
        accessor: "32_@3#",
        Cell: ({ cell }) => (

          (
            <div className="workflow_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Edit
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => handleEdit(cell.row.original.id)}

                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },

      {
        // width: 300,
        Header: "",
        accessor: "32_@#",
        Cell: ({ cell }) => (

          (
            <div className="workflow_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    List
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-file-alt"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => setAudienceIdOnTheURL(cell.row.original)}

                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },

      {
        // width: 300,
        Header: "",
        accessor: "32_@reer#",
        Cell: ({ cell }) => (

          (
            <div className="workflow_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Archive
                  </Tooltip>
                )}
              >
                <i
                  className="far fa-file-archive"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => archiveAudience(cell.row.original.id)}

                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },
    ],
    []
  );

  const data = useMemo(() => dataApi, [dataApi]);

  useEffect(() => {
    dispatch(setAudienceLoading(true));
    getCompany()
      .then((data) => {
        setCompanyName(data.name);
      })
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setAudienceLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    searchText.current.value !== ""
      ? await getOverAllCount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
        })
      : await getOverAllCount()
        .then((data) => {
          setPageCount(Math.ceil(data.overallAudience / pageSize));
          setContact(data);
        })

    searchText.current.value !== ""
      ? await limitAudienceData(pageSize, startRow, searchText.current.value)
        .then((data) => {
          setDataApi(data);
          dispatch(setAudienceLoading(false));
        })
      : await limitAudienceData(pageSize, startRow)
        .then((data) => {
          setDataApi(data);
          dispatch(setAudienceLoading(false));
        })
  }, []);

  const setAudienceIdOnTheURL = (key) => {

    sessionStorage.setItem("audience_list_id", key.id);
    sessionStorage.setItem("audience_list_name", key.name);

    props.history.push(`/admin/contact/audience/list/${key.id}`);
  };

  const handleEdit = (id) => {
    props.history.push(`/admin/contact/audience/create?id=${id}`);

  }
  const archiveAudience = (id) =>{

    if (window.confirm('Do you want to archive this audience?')) {
      putSaveAudienceData({ isDeleted: true, }, id)
        .then((data) => {
          setDataApi((t) => t.filter(i => i.id != id));

          toast.success("Audience has been archived successfully.");
        })
        .catch((e) => {
          toast.error("Somethig went wrong, please try again later.");

        });
      }

  }

  return (
    <Container>
      <div className="top-header-cont" style={{paddingRight:"10px"}}>
      <div className="page_heading">
        <h2>Audience List</h2>
        {dataApi ? (
          <div>
            <p>{companyName}</p>
            <p className="sm d-flex align-items-center">
              You have {contact.overallAudience && contact.overallAudience}{" "}
              Audience
            </p>
          </div>
        ) : null}
      </div>
      <div className="search_bar_wrap d-flex">
            {/* <label className="search_label mr-3">Search</label> */}
            <input
              className="form-control search-input"
              id="search_input"
              placeholder="Enter Name or Description "
              ref={searchText}
              style={{ maxWidth: "23%", marginLeft: "25px" , width:"220px" }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  dispatch(setAudienceLoading(true));
                  fetchData({
                    pageSize: 10,
                    pageIndex: 0,
                    searchText: searchText.current.value,
                  })
                    .then(() => {
                      dispatch(setAudienceLoading(false));
                    })
                }
              }}
            />
            <button
              onClick={() => {
                dispatch(setAudienceLoading(true));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  searchText: searchText.current.value,
                })
                  .then(() => {
                    dispatch(setAudienceLoading(false));
                  })
              }}
              className="lg_btn tertiary search_btn"
              style={{ height: "38px", margin: "0 0 1vh 1vh" }}
            >
              {audienceLoading ? "Loading..." : "Search"}
            </button>
          </div>
          </div>

      <div></div>
      {dataApi ? (
        <div className="dataTableOuter">
    
          <div className="table-flter rdt_Pagination d-flex align-items-center" style={{backgroundColor:"#fff"}}>
            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          {
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={audienceLoading}
            ></Table>
          }
        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
  );
};

export default AudienceDetails;
